import React, {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'

/* Components */
import HbIntersectionMonitor from '../../../../components/Intersection/HbIntersectionMonitor'
import ScriptLoader from '../../../../components/ScriptLoader/ScriptLoader'
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Styles */
import s from './CmsComponent.scss'

class CmsComponent extends PureComponent {
  static propTypes = {
    componentInfo: PropTypes.shape({
      reactHtml: PropTypes.string,
      reactStyle: PropTypes.string,
      jsList: PropTypes.array,
    }),
    style: PropTypes.object,
    options: PropTypes.object,
    ratio: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const {options} = props;

    this.state = {
      loadedScriptsLength: 0,
      htmlOptions: {
        render: !options?.onlyClientSide,
      },
    }
  }

  onScriptLoad = () => {
    this.setState((state, props) => {
      return {
        loadedScriptsLength: state.loadedScriptsLength + 1,
      };
    });
  };

  scriptsRender = () => {
    const {
      componentInfo: {
        jsList,
      },
    } = this.props;

    if (!jsList) {
      return null;
    }

    return (
      jsList.map(script => (
        <ScriptLoader
          key={script}
          src={script}
          onLoad={this.onScriptLoad}/>
      ))
    );
  }

  inlineScriptsRender = () => {
    const {
      componentInfo: {
        hydrate,
        jsList,
      },
    } = this.props;

    const {
      loadedScriptsLength,
    } = this.state;

    const isAllscriptsLoaded = loadedScriptsLength >= jsList?.length || 0;

    if (!isAllscriptsLoaded || !hydrate) {
      return false;
    }

    return <ScriptLoader children={hydrate}/>
  }

  handleObserverChange = entry => {
    const {
      htmlOptions,
    } = this.state;

    if (entry.isIntersecting) {
      this.setState({
        htmlOptions: {
          ...htmlOptions,
          render: true,
        },
      })
    }
  };

  render() {
    const {
      componentInfo,
      style,
      ratio,
    } = this.props;

    const {
      htmlOptions,
    } = this.state;

    const intersectionObserverEnabled = !htmlOptions.render;
    const WrapperElement = intersectionObserverEnabled
      ? HbIntersectionMonitor
      : Fragment;
    const wrapperProps = intersectionObserverEnabled
      ? {
        onIntersectionChange: this.handleObserverChange,
      }
      : {};

    return (
      <WrapperElement
        {...wrapperProps}>
        <div
          id={`cms-component-${componentInfo?.id}`}
          style={style}
          className={s.root}>
          {
            componentInfo && htmlOptions.render ?
              <>
                {
                  this.scriptsRender()
                }
                {
                  this.inlineScriptsRender()
                }
                {
                  componentInfo?.reactStyle &&
                  <div dangerouslySetInnerHTML={{__html: componentInfo.reactStyle}}/>
                }
                {
                  componentInfo?.reactHtml &&
                  <div dangerouslySetInnerHTML={{__html: componentInfo.reactHtml}}/>
                }
              </>
              : ratio ?
                <HbPlaceholderFrame
                  className={s.placeholder}
                  contentClassName={s.placeholderContent}
                  ratio={ratio}>
                  <div className={s.loading} />
                </HbPlaceholderFrame>
                : null
          }
        </div>
      </WrapperElement>
    )
  }
}

export default CmsComponent;
